import { MenuItemInterface } from '../interfaces/menu-item.interface';
import { UserRoleEnum } from '@enums/user-role.enum';
import { ServiceRequestMenuStatusEnum } from '@enums/service-request-menu-status.enum';
import { IconsEnum } from '@enums/icons.enum';

export const BUSINESS_UNIT_ID_REPLACEMENT_KEY = ':businessUnitId';

/**
 * UserRoleEnum.DRIVER
 */
const DRIVER_MENU_ITEMS: MenuItemInterface[] = [
  {
    id: '1',
    name: 'Driver Dashboard',
    icon: 'fa fa-car',
    routerLink: '/driver-dashboard',
  },
  {
    id: '3',
    name: 'Calendar',
    icon: 'fa fa-calendar',
    routerLink: '/v2/driver-scheduling',
  },
  {
    id: '3',
    name: 'Issues & Feedback',
    icon: 'fa fa-exclamation-circle',
    routerLink: '/issues-feedback/assigned-to-me',
  },
];

/**
 * UserRoleEnum.VENDOR_DRIVER
 */
const VENDOR_DRIVER_MENU_ITEMS: MenuItemInterface[] = [
  {
    id: '1',
    name: 'Driver Dashboard',
    icon: 'fa fa-car',
    routerLink: '/driver-dashboard',
  },
];

/**
 * UserRoleEnum.CUSTOMER_ADMIN
 */
const CUSTOMER_ADMIN_MENU_ITEMS: MenuItemInterface[] = [
  {
    id: '1',
    name: 'Customer Dashboard',
    icon: 'fa fa-user-circle  fa-lg',
    routerLink: '/v2/customer-dashboard',
  },
  {
    id: '2',
    name: 'Service Request',
    icon: 'fa fa-vcard fa-lg',
    children: [
      {
        id: '2.1',
        name: 'Requested',
        icon: '',
        svgIcon: IconsEnum.CUSTOMER_DETAILS,
        routerLink: '/v2/service-requests',
        queryParams: { status: ServiceRequestMenuStatusEnum.PENDING },
      },
      {
        id: '2.2',
        name: 'Not Started',
        icon: '',
        svgIcon: IconsEnum.TIME,
        routerLink: '/v2/service-requests',
        queryParams: { status: ServiceRequestMenuStatusEnum.NOT_STARTED },
      },
      {
        id: '2.3',
        name: 'Active',
        icon: '',
        svgIcon: IconsEnum.SWAP_DRIVING_APPS,
        routerLink: '/v2/service-requests',
        queryParams: { status: ServiceRequestMenuStatusEnum.EN_ROUTE },
      },
      {
        id: '2.4',
        name: 'Completed',
        icon: 'fa fa-check-square-o',
        routerLink: '/v2/service-requests',
        queryParams: { status: ServiceRequestMenuStatusEnum.COMPLETED },
      },
    ],
  },
  {
    id: '3',
    name: 'Customer Detail',
    icon: 'fa fa-list-alt fa-lg',
    routerLink: `/v2/customer-details`,
  },
  {
    id: '4',
    name: 'Members',
    icon: 'fa fa-users fa-lg',
    routerLink: `v2/members`,
  },
];

/**
 * UserRoleEnum.CUSTOMER_COORDINATOR
 */
const CUSTOMER_COORDINATOR_MENU_ITEMS: MenuItemInterface[] = CUSTOMER_ADMIN_MENU_ITEMS;

/**
 * UserRoleEnum.VENDOR_ADMIN
 */
const VENDOR_ADMIN_MENU_ITEMS: MenuItemInterface[] = [
  {
    id: '1',
    name: 'Vendor Dashboard',
    icon: 'fa fa-truck fa-lg',
    routerLink: '/vendor-dashboard',
  },
  {
    id: '2',
    name: 'Service Requests',
    icon: 'fa fa-file fa-lg',
    routerLink: '/sr-page',
  },
  {
    id: '3',
    name: 'Vendor Detail',
    icon: 'fa fa-ambulance fa-lg',
    routerLink: `/businessUnit-details/vendor/${BUSINESS_UNIT_ID_REPLACEMENT_KEY}`,
  },
  {
    id: '4',
    name: 'Vehicle Management',
    icon: 'fa fa-truck fa-lg',
    routerLink: `/vehicle-management/${BUSINESS_UNIT_ID_REPLACEMENT_KEY}`,
  },
  {
    id: '5',
    name: 'Members',
    icon: 'fa fa-users fa-lg',
    routerLink: `/members/${BUSINESS_UNIT_ID_REPLACEMENT_KEY}`,
  },
  {
    id: '6',
    name: 'Notes',
    icon: 'fa fa-file fa-lg',
    routerLink: `/notes/${BUSINESS_UNIT_ID_REPLACEMENT_KEY}`,
  },
  {
    id: '7',
    name: 'Files',
    icon: 'fa fa-files-o fa-lg',
    routerLink: `/files/${BUSINESS_UNIT_ID_REPLACEMENT_KEY}`,
  },
];

/**
 * UserRoleEnum.VENDOR_COORDINATOR
 */
const VENDOR_COORDINATOR_MENU_ITEMS: MenuItemInterface[] = VENDOR_ADMIN_MENU_ITEMS;

/**
 * UserRoleEnum.ACCOUNTING
 */
const ACCOUNTING_MENU_ITEMS: MenuItemInterface[] = [
  // {
  //   id: '1',
  //   name: 'Finance Dashboard',
  //   icon: 'fa fa-money fa-lg',
  //   routerLink: '/finance-dashboard',
  // },
  {
    id: '2',
    name: 'Manage Customer',
    icon: 'fa fa-list-alt fa-lg',
    routerLink: '/customer-list',
  },
  {
    id: '3',
    name: 'Service Request',
    icon: 'fa fa-vcard fa-lg',
    routerLink: '/service-request',
  },
  {
    id: '4',
    name: 'Driver Utilization',
    icon: 'fa fa-hourglass-start',
    routerLink: '/v2/reports',
  },
  {
    id: '5',
    name: 'Manage Data',
    icon: 'fa fa-user-secret fa-lg',
    routerLink: '/manage-data',
  },
  {
    id: '6',
    name: 'Reports',
    icon: 'fa fa-bar-chart fa-lg',
    routerLink: '/customer-report/report',
  },
  {
    id: '7',
    name: 'Issues & Feedback',
    icon: 'fa fa-exclamation-circle',
    routerLink: '/issues-feedback/assigned-to-me',
  },
  {
    id: '8',
    name: 'Calendar',
    icon: 'fa fa-calendar',
    routerLink: '/v2/driver-scheduling',
  },
];

/**
 * UserRoleEnum.MANAGEMENT
 */
const MANAGEMENT_MENU_ITEMS: MenuItemInterface[] = [
  {
    id: '1',
    name: 'Driver Dashboard',
    icon: 'fa fa-car',
    routerLink: '/driver-dashboard',
  },
  // {
  //   id: '3',
  //   name: 'Vendor Dashboard',
  //   icon: 'fa fa-truck  fa-lg',
  //   routerLink: '/vendor-dashboard',
  // },
  {
    id: '5',
    name: 'Service Request',
    icon: 'fa fa-list fa-lg',
    routerLink: '/service-request',
  },
  {
    id: '6',
    name: 'Customer SR Queue',
    icon: 'fa fa-th-list fa-lg',
    routerLink: '/service-request-queue',
  },
  {
    id: '7',
    name: 'Manage Vendor',
    icon: 'fa fa-ambulance fa-lg',
    routerLink: '/manage-vendor',
  },
  {
    id: '8',
    name: 'Manage Customer',
    icon: 'fa fa-list-alt fa-lg',
    routerLink: '/customer-list',
  },
  {
    id: '9',
    name: 'Manage Member',
    icon: 'fa fa-list-alt fa-lg',
    routerLink: '/member-list',
  },
  {
    id: '10',
    name: 'Manage Vehicle',
    icon: 'fa fa-truck fa-lg',
    routerLink: '/manage-vehicle',
  },
  {
    id: '11',
    name: 'Manage Data',
    icon: 'fa fa-user-secret fa-lg',
    routerLink: '/manage-data',
  },
  {
    id: '12',
    name: 'Reports',
    icon: 'fa fa-bar-chart fa-lg',
    routerLink: '/customer-report/report',
  },
  {
    id: '13',
    name: 'Driver Utilization',
    icon: 'fa fa-hourglass-start',
    routerLink: '/v2/reports',
  },
  {
    id: '14',
    name: 'Issues & Feedback',
    icon: 'fa fa-exclamation-circle',
    routerLink: '/issues-feedback/assigned-to-me',
  },
  {
    id: '15',
    name: 'Calendar',
    icon: 'fa fa-calendar',
    routerLink: '/v2/driver-scheduling',
  },
];

/**
 * UserRoleEnum.COORDINATOR
 */
const COORDINATOR_MENU_ITEMS: MenuItemInterface[] = [
  {
    id: '2',
    name: 'Driver Dashboard',
    icon: 'fa fa-car',
    routerLink: '/driver-dashboard',
  },
  {
    id: '4',
    name: 'Service Request',
    icon: 'fa fa-list fa-lg',
    routerLink: '/service-request',
  },
  {
    id: '5',
    name: 'Customer SR Queue',
    icon: 'fa fa-th-list fa-lg',
    routerLink: '/service-request-queue',
  },
  {
    id: '6',
    name: 'Manage Vendor',
    icon: 'fa fa-ambulance fa-lg',
    routerLink: '/manage-vendor',
  },
  {
    id: '7',
    name: 'Manage Customer',
    icon: 'fa fa-list-alt fa-lg',
    routerLink: '/customer-list',
  },
  {
    id: '8',
    name: 'Manage Member',
    icon: 'fa fa-list-alt fa-lg',
    routerLink: '/member-list',
  },
  {
    id: '9',
    name: 'Manage Vehicle',
    icon: 'fa fa-truck fa-lg',
    routerLink: '/manage-vehicle',
  },
  {
    id: '10',
    name: 'Manage Data',
    icon: 'fa fa-user-secret fa-lg',
    routerLink: '/manage-data',
  },
  {
    id: '11',
    name: 'Reports',
    icon: 'fa fa-bar-chart fa-lg',
    routerLink: '/customer-report/report',
  },
  {
    id: '12',
    name: 'Driver Utilization',
    icon: 'fa fa-hourglass-start',
    routerLink: '/v2/reports',
  },
  {
    id: '13',
    name: 'Issues & Feedback',
    icon: 'fa fa-exclamation-circle',
    routerLink: '/issues-feedback/assigned-to-me',
  },
  {
    id: '14',
    name: 'Calendar',
    icon: 'fa fa-calendar',
    routerLink: '/v2/driver-scheduling',
  },
];

/**
 * UserRoleEnum.EXECUTIVE_ADMIN
 */
const EXECUTIVE_ADMIN_MENU_ITEMS: MenuItemInterface[] = [
  {
    id: '1',
    name: 'Driver Dashboard',
    icon: 'fa fa-car',
    routerLink: '/driver-dashboard',
  },
  // {
  //   id: '4',
  //   name: 'Vendor Dashboard',
  //   icon: 'fa fa-truck  fa-lg',
  //   routerLink: '/vendor-dashboard',
  // },
  // {
  //   id: '4',
  //   name: 'Finance Dashboard',
  //   icon: 'fa fa-money fa-lg',
  //   routerLink: '/finance-dashboard',
  // },
  {
    id: '6',
    name: 'Service Request',
    icon: 'fa fa-list fa-lg',
    routerLink: '/service-request',
  },
  {
    id: '7',
    name: 'Customer SR Queue',
    icon: 'fa fa-th-list fa-lg',
    routerLink: '/service-request-queue',
  },
  {
    id: '8',
    name: 'Manage Vendor',
    icon: 'fa fa-ambulance fa-lg',
    routerLink: '/manage-vendor',
  },
  {
    id: '9',
    name: 'Manage Customer',
    icon: 'fa fa-list-alt fa-lg',
    routerLink: '/customer-list',
  },
  {
    id: '10',
    name: 'Manage Member',
    icon: 'fa fa-list-alt fa-lg',
    routerLink: '/member-list',
  },
  {
    id: '11',
    name: 'Manage Vehicle',
    icon: 'fa fa-truck fa-lg',
    routerLink: '/manage-vehicle',
  },
  {
    id: '12',
    name: 'Manage Data',
    icon: 'fa fa-user-secret fa-lg',
    routerLink: '/manage-data',
  },
  {
    id: '13',
    name: 'Reports',
    icon: 'fa fa-bar-chart fa-lg',
    routerLink: '/customer-report/report',
  },
  {
    id: '14',
    name: 'Driver Utilization',
    icon: 'fa fa-hourglass-start',
    routerLink: '/v2/reports',
  },
  {
    id: '15',
    name: 'Issues & Feedback',
    icon: 'fa fa-exclamation-circle',
    routerLink: '/issues-feedback/assigned-to-me',
  },
  {
    id: '16',
    name: 'Calendar',
    icon: 'fa fa-calendar',
    routerLink: '/v2/driver-scheduling',
  },
];

/**
 * UserRoleEnum.INTERNAL_READONLY
 */
const INTERNAL_READ_ONLY_MENU_ITEMS: MenuItemInterface[] = [
  {
    id: '1',
    name: 'Dashboard',
    icon: 'fa fa-tachometer fa-lg',
    routerLink: '/executive-dashboard',
  },
  {
    id: '2',
    name: 'Driver Dashboard',
    icon: 'fa fa-car',
    routerLink: '/driver-dashboard',
  },
  // {
  //   id: '5',
  //   name: 'Vendor Dashboard',
  //   icon: 'fa fa-truck  fa-lg',
  //   routerLink: '/vendor-dashboard',
  // },
  // {
  //   id: '4',
  //   name: 'Finance Dashboard',
  //   icon: 'fa fa-money fa-lg',
  //   routerLink: '/finance-dashboard',
  // },
  {
    id: '6',
    name: 'Service Request',
    icon: 'fa fa-list fa-lg',
    routerLink: '/service-request',
  },
  {
    id: '7',
    name: 'Manage Vendor',
    icon: 'fa fa-ambulance fa-lg',
    routerLink: '/manage-vendor',
  },
  {
    id: '8',
    name: 'Manage Customer',
    icon: 'fa fa-list-alt fa-lg',
    routerLink: '/customer-list',
  },
  {
    id: '9',
    name: 'Manage Member',
    icon: 'fa fa-list-alt fa-lg',
    routerLink: '/member-list',
  },
  {
    id: '10',
    name: 'Manage Vehicle',
    icon: 'fa fa-truck fa-lg',
    routerLink: '/manage-vehicle',
  },
  {
    id: '11',
    name: 'Manage Data',
    icon: 'fa fa-user-secret fa-lg',
    routerLink: '/manage-data',
  },
  {
    id: '12',
    name: 'Reports',
    icon: 'fa fa-bar-chart fa-lg',
    routerLink: '/customer-report/report',
  },
  {
    id: '13',
    name: 'Driver Utilization',
    icon: 'fa fa-hourglass-start',
    routerLink: '/v2/reports',
  },
  {
    id: '14',
    name: 'Issues & Feedback',
    icon: 'fa fa-exclamation-circle',
    routerLink: '/issues-feedback/assigned-to-me',
  },
  {
    id: '15',
    name: 'Calendar',
    icon: 'fa fa-calendar',
    routerLink: '/v2/driver-scheduling',
  },
];

/**
 * Map where menu items attached to according user role
 */
export const MENU_ITEMS_BY_ROLE: Map<UserRoleEnum, MenuItemInterface[]> = new Map([
  [UserRoleEnum.DRIVER, DRIVER_MENU_ITEMS],
  [UserRoleEnum.VENDOR_DRIVER, VENDOR_DRIVER_MENU_ITEMS],
  [UserRoleEnum.CUSTOMER_ADMIN, CUSTOMER_ADMIN_MENU_ITEMS],
  [UserRoleEnum.CUSTOMER_COORDINATOR, CUSTOMER_COORDINATOR_MENU_ITEMS],
  [UserRoleEnum.VENDOR_ADMIN, VENDOR_ADMIN_MENU_ITEMS],
  [UserRoleEnum.VENDOR_COORDINATOR, VENDOR_COORDINATOR_MENU_ITEMS],
  [UserRoleEnum.ACCOUNTING, ACCOUNTING_MENU_ITEMS],
  [UserRoleEnum.MANAGEMENT, MANAGEMENT_MENU_ITEMS],
  [UserRoleEnum.COORDINATOR, COORDINATOR_MENU_ITEMS],
  [UserRoleEnum.EXECUTIVE_ADMIN, EXECUTIVE_ADMIN_MENU_ITEMS],
  [UserRoleEnum.INTERNAL_READONLY, INTERNAL_READ_ONLY_MENU_ITEMS],
]);
